import { jsx as _jsx } from "react/jsx-runtime";
import { DialogContentStyled } from './DialogContent.styled';
export const DialogContent = (props) => {
    return _jsx(DialogContentStyled, { ...props });
};
